import { ListRepository } from '@/repository/list/ListRepository';
import * as APITypes from '@/API';
import { StaffSeed } from '@/API';
import { GraphQLResult } from 'aws-amplify/api';
import * as queries from '@/graphql/queries';
import { GraphQLOptionsV6 } from '@aws-amplify/api-graphql';
import { FilterDefinition } from '@lambda-layer/models/FilterDefinition/FilterDefinition.ts';
import { FilterSelections } from '@lambda-layer/types/filter.ts';
import { buildCountQuery } from '@lambda-layer/utils/queryUtils';

export class StaffSeedRepository extends ListRepository<StaffSeed> {
  public async search(queryVariables: GraphQLOptionsV6['variables']) {
    return (
      await this.client.graphql({
        query: queries.searchStaffSeeds,
        variables: queryVariables,
      })
    ).data.searchStaffSeeds;
  }

  async count(
    filterDefinitions: FilterDefinition[],
    filterSelections: FilterSelections
  ): Promise<number> {
    const { data } = (await this.client.graphql({
      query: buildCountQuery(
        'searchStaffSeeds',
        filterDefinitions,
        filterSelections
      ),
    })) as GraphQLResult<APITypes.SearchStaffSeedsQuery>;
    return data.searchStaffSeeds?.total || 0;
  }

  protected async getSearchableAggregateBucketResultItems(
    dbColumn: string,
    filterDefinitions: FilterDefinition[],
    filterSelections: FilterSelections
  ) {
    const { data } = (await this.client.graphql({
      query: this.createAggregateQuery(
        dbColumn,
        'searchStaffSeeds',
        filterDefinitions,
        filterSelections
      ),
    })) as GraphQLResult<APITypes.SearchStaffSeedsQuery>;

    const total = data?.searchStaffSeeds?.total ?? 0;

    const buckets =
      (
        data?.searchStaffSeeds?.aggregateItems?.[0]
          ?.result as APITypes.SearchableAggregateBucketResult
      )?.buckets ?? [];

    return { buckets, total };
  }
}
